import { Amount } from "../../core/amount/amount";
import type { Account } from "./account";

export function useAccountBalance(account: Account) {
  const balance = account.balances[0];
  return {
    balance: new Amount(balance.value, balance.currency),
  };
}
